<app-relatorio-container
    tituloRelatorio="Requerimento de Renovação de Regularidade"
    descricaoRelatorio="Requerimento de renovação com certidão de regularidade"
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'requerimento-renovacao-regularidade-pj.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6" [formGroup]="form">
            <p class="text-sm text-color-secondary m-0">
                O requerimento é emitido para o prestador selecionado, com as assinaturas do diretor técnico e do diretor clínico. Informe a data da última alteração do documento de constituição e a situação do corpo clínico.
            </p>

            <div class="field">
                <label for="dataAlteracao" class="font-semibold block mb-2">Data da última alteração do documento de constituição</label>
                <p-date-picker inputId="dataAlteracao" dateFormat="dd/mm/yy" dataType="date" formControlName="dataAlteracao" [appendTo]="'body'" fluid class="w-full" placeholder="dd/mm/aaaa" [showClear]="true"></p-date-picker>
            </div>

            <div class="field">
                <label class="font-semibold block mb-2">Corpo Clínico</label>
                <div class="flex flex-col gap-2">
                    <div class="flex items-center gap-2">
                        <p-radioButton inputId="corpoSemAlteracao" [value]="false" formControlName="alteracaoCorpoClinico"></p-radioButton>
                        <label for="corpoSemAlteracao" class="cursor-pointer">Corpo Clínico sem alterações desde a última renovação.</label>
                    </div>
                    <div class="flex items-center gap-2">
                        <p-radioButton inputId="corpoAlterado" [value]="true" formControlName="alteracaoCorpoClinico"></p-radioButton>
                        <label for="corpoAlterado" class="cursor-pointer">Corpo Clínico alterado (anexar alterações).</label>
                    </div>
                </div>
            </div>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Requerimento" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
